<div class="standardpanel">
  <div class="titleblock">
    <h3 class="title1level">Creazione Pratica veloce</h3>
  </div>

  <!-- DATI GENERALI PRATICA -->
  <div class="container_dati_generali">
    <h3 class="title2level">Dati generali pratica</h3>
    <div class="row">
      <div comboModInput class="col-sm-6"
           [labelInput]="'Tipo pratica'"
           [mandatory]="true"
           [optionsCombo]="tipiPratica"
           [objectReference]="pratica.tipoPratica"
           (onReturn)="setTipoPratica($event)"
           [labelOption]="'descrizione'">
      </div>
      <div comboModInput class="col-sm-6"
           [labelInput]="'Tipo fascicolo'"
           [mandatory]="true"
           [submitPending]="!tipiFascicolo.length"
           [optionsCombo]="tipiFascicolo"
           [objectReference]="fascicolo.tipoFascicolo"
           (onReturn)="fascicolo.tipoFascicolo = $event">
      </div>
    </div>
    <div class="row">
      <div textAreaInput class="col-sm-12" [labelInput]="'Note'"
           [(ngModel)]="pratica.note">
      </div>
    </div>
  </div>

  <!-- CLASSIFICAZIONI -->
  <div class="container_dati_generali">
    <h3 class="title2level">Classificazioni</h3>
    <div *ngIf="sezioneClassificazione.classificazioni.length">
      <table class="table-striped table aggiunta_classificazione">
        <caption class="sr-only">Tabella classificazione</caption>
        <tbody>
        <tr>
          <th>Materia</th>
          <th>Oggetto</th>
          <th>Argomento</th>
          <th>Primaria</th>
          <th></th>
        </tr>
        <tr *ngFor="let classificazione of sezioneClassificazione.classificazioni; let iClass = index;">
          <td>{{classificazione.materia ? classificazione.materia.label : ''}}</td>
          <td>{{classificazione.oggetto ? classificazione.oggetto.label : ''}}</td>
          <td>{{classificazione.argomento ? classificazione.argomento.label : ''}}</td>
          <td>{{classificazione.isPrincipale ? 'Si' : 'No'}}</td>
          <td>
            <button role="button" class="btn-link" aria-label="rimuovi classificazione" (click)="removeClassificazione(iClass);">
              <span class="glyphicon glyphicon-trash"></span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <p *ngIf="!sezioneClassificazione.classificazioni.length">Inserire una classificazione.</p>
    <div class="row">
      <div comboModInput class="col-sm-3" [labelInput]="'Materia'"
           [mandatory]="true" [optionsCombo]="materie"
           [objectReference]="classificazione.materia"
           [ngModel]="classificazione.materia"
           (onReturn)="materiaChange($event)">
      </div>
      <div comboModInput class="col-sm-3" [labelInput]="'Oggetto'"
           [mandatory]="true" [optionsCombo]="oggetti"
           [submitPending]="!classificazione.materia"
           [objectReference]="classificazione.oggetto"
           [ngModel]="classificazione.oggetto"
           (onReturn)="oggettoChange($event)">
      </div>
      <div comboModInput class="col-sm-3" [labelInput]="'Argomento'"
           [optionsCombo]="argomenti"
           [submitPending]="!classificazione.oggetto"
           [objectReference]="classificazione.argomento"
           [ngModel]="classificazione.argomento"
           (onReturn)="classificazione.argomento = $event">
      </div>
      <div singleCheckBoxModInput class="col-sm-3"
           [labelInput]="'Primaria'"
           [objectReference]="classificazione.isPrincipale"
           (onReturn)="classificazione.isPrincipale = $event">
      </div>
    </div>
    <div class="row">
      <p class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9">
        <button (click)="addClassificazione()"
                [disabled]="(!classificazione.oggetto) || isClassificazioneAlreadyPresent(classificazione)"
                type="button" class="btn btn-primary btn-block">Aggiungi classificazione
        </button>
      </p>
    </div>
  </div>


  <!-- DATI GENERALI FASCICOLO -->
  <div class="container_dati_generali">
    <h3 class="title2level">Dati generali fascicolo</h3>
    <div class="row">
      <div datePickerInput class="col-sm-4" [labelInput]="'Data apertura'"
           [dataAl]="fascicolo.dataDefinizione"
           [(ngModel)]="fascicolo.dataInizioFascicolo"
           [mandatory]="true">
      </div>
      <div comboModInput class="col-sm-4" [labelInput]="'Natura'"
           [mandatory]="true"
           [ngModel]="fascicolo.natura"
           [objectReference]="fascicolo.natura"
           (onReturn)="fascicolo.natura = $event"
           [optionsCombo]="tipiNatura">
      </div>
      <div singleCheckBoxModInput class="col-sm-4"
           [labelInput]="'Fondo rischi'" idInput="fondo_rischi-rapid"
           [objectReference]="fascicolo.flagFondoRischi"
           (onReturn)="fascicolo.flagFondoRischi = $event">
      </div>
    </div>
    <div class="row">
      <div comboModInput class="col-sm-4" [labelInput]="'Grado'" [location]="'mesi'"
           [labelOption]="'descrizione'"
           [objectReference]="fascicolo.grado"
           (onReturn)="fascicolo.grado = $event"
           [optionsCombo]="gradi">
      </div>
      <!-- forse questi non sono campi generici
      <div textInput class="col-sm-4" [labelInput]="'N&deg; ruolo'"
           [(ngModel)]="fascicolo.numeroRuolo">
      </div>
      <div naturalNumberInput class="col-sm-4" [labelInput]="'Anno ruolo'" [maxLength]="4"
           [checkFormat]="true" [(ngModel)]="fascicolo.annoRuolo">
      </div>
  </div>
  <div class="row">
      <div comboModInput class="col-sm-3"
           [labelInput]="'Autorit&agrave; giudiziaria'"
           [labelOption]="'descrizione'"
           [optionsCombo]="autoritaGiudiziarie" [mandatory]="true"
           [objectReference]="fascicolo.autoritaGiudiziaria"
           [ngModel]="fascicolo.autoritaGiudiziaria"
           (onReturn)="autoritaGiudiziariaChange($event)">
      </div>
      <div comboModInput class="col-sm-3" [mandatory]="true"
           [labelInput]="'Sede autorit&agrave;'"
           [optionsCombo]="cittaPerAutoritaGiudiziaria"
           [submitPending]="!fascicolo.autoritaGiudiziaria"
           [objectReference]="fascicolo.autoritaGiudiziariaCitta"
           [ngModel]="fascicolo.autoritaGiudiziariaCitta"
           (onReturn)="fascicolo.autoritaGiudiziariaCitta = $event">
      </div>
      <div textInput class="col-sm-3" [labelInput]="'Sezione'"
           [(ngModel)]="fascicolo.sezione">
      </div>
      <div textInput class="col-sm-3" [labelInput]="'Giudice'"
           [(ngModel)]="fascicolo.giudice">
      </div>
      -->
    </div>
    <div class="row">
      <div textAreaInput class="form-group col-xs-12 col-sm-12"
           [labelInput]="'Note'" [(ngModel)]="fascicolo.note">
      </div>
    </div>
  </div>

  <!-- CONTROPARTI -->
  <div class="container_dati_generali">
    <h3 class="title2level">Parti</h3>
    <p *ngIf="!sezioneControparti.controparti.length && !controparte.parte">Inserire una parte.</p>

    <ul id="controparticollapse" class="controparti" *ngIf="sezioneControparti.controparti.length">
      <li class="panel" *ngFor="let controparte of sezioneControparti.controparti; let i = index">
        <div class="controparte">
          <div class="data_opzioni">
            <ul>
              <li class="star" *ngIf="controparte.primario"></li>
              <li>
                <a href="javascript:void(0)" (click)="rimuoviControparte(i)">
                  <span class="glyphicon glyphicon-trash"></span>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <a [attr.data-toggle]="'collapse'" href="#subcontroparte{{i}}"
               [attr.aria-expanded]="false" class="collapsed"
               [attr.aria-controls]="'subcontroparte'+i"
               [attr.data-parent]="'#controparticollapse'">
              <span>Apri</span>
            </a>
            <h4 class="titolo col-sm-4">{{controparte.parte.nominativo}}</h4>
            <p class="col-sm-3" *ngIf="controparte.parte.tipoPersona.label == 'FISICA'">
              C/F: <strong> {{controparte.parte.codiceFiscale}} </strong>
            </p>
            <p class="col-sm-3" *ngIf="controparte.parte.tipoPersona.label == 'FISICA'">
              MAT: <strong> {{controparte.parte.matricola}} </strong>
            </p>
            <p class="col-sm-3" *ngIf="controparte.parte.tipoPersona.label == 'GIURIDICA'">
              P.IVA: <strong> {{controparte.parte.partitaIva}} </strong>
            </p>
            <p *ngIf="controparte.ritirato" class="col-sm-2 status">Rinunciatario</p>
          </div>
        </div>
        <ul class="collapse subcontroparte" id="subcontroparte{{i}}">
          <li>
            <div class="container_tab_nav">
              <p>Visualizza</p>
              <ul class="nav nav-tabs two">
                <li class="active"><a data-toggle="tab" href="#tabcontent1_{{i}}">Associativa</a></li>
                <li><a data-toggle="tab" href="#tabcontent2_{{i}}">Anagrafica</a></li>
              </ul>
              <div class="tab-content">
                <div id="tabcontent1_{{i}}" class="tab-pane fade in active">

                  <div class="row">
                    <div labelTextInput class="col-sm-4 bloccodati"
                         [typeLabel]="'text'" [labelInput]="'Legale di parte'"
                         [valueInput]="controparte.legaleControparte ? (controparte.legaleControparte?.parte.nominativo) : ''">
                    </div>
                    <!--<div labelTextInput class="col-sm-2 bloccodati"
                         [typeLabel]="'date'" [labelInput]="'Data associazione'"
                         [valueInput]="controparte.dataAssociazione">
                    </div>-->
                    <div labelTextInput class="col-sm-2 bloccodati"
                         [typeLabel]="'boolean'" [labelInput]="'Cliente'"
                         [valueInput]="controparte.cliente">
                    </div>
                    <div labelTextInput class="col-sm-2 bloccodati"
                         [typeLabel]="'boolean'" [labelInput]="'Rinunciatario'"
                         [valueInput]="controparte.ritirato">
                    </div>
                    <div labelTextInput class="col-sm-2 bloccodati"
                         [typeLabel]="'date'" [labelInput]="'Data rinuncia'"
                         [valueInput]="controparte.dataTermine">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 bloccodati">
                      <p>
                        <label class="col-sm-12">Note</label>
                        <span class="longtext">{{controparte.note}}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div id="tabcontent2_{{i}}" class="tab-pane fade">
                  <div controparte_anagrafica_view [controparte]="controparte"></div>
                </div>

              </div>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <div ricerca-anagrafiche-form #ricercaControparte
         (onReturn)="selezionaControparte($event)"
         [hidden]="controparte.parte">
    </div>
    <div *ngIf="controparte.parte">
      <div class="row" *ngIf="controparte.parte.tipoPersona.label == 'FISICA'">
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Cognome/Nome'"
             [valueInput]="controparte.parte.nominativo">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Tipo persona'" [valueInput]="controparte.parte.tipoPersona?.label">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Matricola'" [valueInput]="controparte.parte.matricola">
        </div>
        <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Codice fiscale'" [valueInput]="controparte.parte.codiceFiscale">
        </div>
      </div>
      <div class="row" *ngIf="controparte.parte.tipoPersona.label == 'GIURIDICA'">
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Ragione sociale'"
             [valueInput]="controparte.parte.ragioneSociale">
        </div>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Tipo persona'" [valueInput]="controparte.parte.tipoPersona?.label">
        </div>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Partita iva'" [valueInput]="controparte.parte.partitaIva">
        </div>
      </div>
      <div class="row">
        <!--<div datePickerInput [mandatory]="true" class="col-sm-3"
             [labelInput]="'Data associazione'" [dataAl]="controparte.dataTermine"
             [(ngModel)]="controparte.dataAssociazione">
        </div>-->
        <div singleCheckBoxModInput class="col-sm-2" [labelInput]="'Primaria'"
             idInput="primario-rapid" [objectReference]="controparte.primario"
             (onReturn)="controparte.primario = $event">
        </div>
        <div singleCheckBoxModInput class="col-sm-2" [labelInput]="'Cliente'"
             idInput="cliente-rapid" [objectReference]="controparte.cliente"
             (onReturn)="controparte.cliente = $event">
        </div>
        <div singleCheckBoxModInput class="col-sm-2" [labelInput]="'Rinunciatario'"
             idInput="ritirato-rapid"
             [objectReference]="controparte.ritirato"
             (change)="controparte.dataTermine = undefined"
             (onReturn)="controparte.ritirato = $event">
        </div>
        <div datePickerInput class="col-sm-3" [labelInput]="'Data rinuncia'"
             [submitPending]="!controparte.ritirato" [dataDal]="controparte.dataAssociazione"
             [(ngModel)]="controparte.dataTermine">
        </div>
      </div>
      <div class="row">
        <div textAreaInput class="col-sm-12" [labelInput]="'Note'" [(ngModel)]="controparte.note"></div>
      </div>
      <div class="row">
        <p submitButton [disabled]="!controparte.dataAssociazione"
           class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9"
           [labelButton]="'Aggiungi controparte'" (click)="aggiungiControparte()">
        </p>
      </div>
    </div>
  </div>

  <!-- ATTI -->
  <div class="container_dati_generali">
    <h3 class="title2level">Atti</h3>
    <p *ngIf="!sezioneAtti.atti.length">Inserire un atto.</p>

    <ul *ngIf="sezioneAtti.atti.length" id="atticollapse" class="controparti">
      <li class="panel" *ngFor="let atto of sezioneAtti.atti; let i = index">
        <div class="controparte">
          <div class="data_opzioni">
            <ul>
              <li>
                <a href="javascript:void(0)" (click)="rimuoviAtto(i)">
                  <span class="glyphicon glyphicon-trash"></span>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <a [attr.data-toggle]="'collapse'" href="#subatto{{i}}"
               aria-expanded="false" [attr.aria-controls]="'subatto'+i"
               [attr.data-parent]="'#atticollapse'" class="collapsed"><span>Apri</span></a>
            <h4 class="titolo col-sm-5">
              <a [attr.data-toggle]="'collapse'" href="#subatto{{i}}"
                 aria-expanded="false" [attr.aria-controls]="'subatto'+i"
                 [attr.data-parent]="'#atticollapse'">{{atto.tipoAtto.descrizione}}</a>
            </h4>
            <p class="col-sm-2">
              <strong>{{atto.provenienza.descrizione}}</strong>
            </p>
            <p class="col-sm-2">
              Data <strong>{{ atto.dataProtocollo ?
                (atto.dataProtocollo | date:'dd/MM/yyyy') : '' }}</strong>
            </p>
            <p class="col-sm-3">
              N&deg; protocollo: <strong>{{ atto.numeroProtocollo ?
                atto.numeroProtocollo : '' }}</strong>
            </p>
          </div>
        </div>
        <ul class="collapse subcontroparte" id="subatto{{i}}">
          <li>
            <div class="container_dati_generali">
              <div class="row">
                <div labelTextInput class="col-sm-12 bloccodati"
                     [typeLabel]="'text'" [labelInput]="'Tipo atto'"
                     [valueInput]="atto.tipoAtto?.descrizione">
                </div>
              </div>
              <div class="row">
                <div labelTextInput class="col-sm-4 bloccodati"
                     [typeLabel]="'text'" [labelInput]="'Provenienza'"
                     [valueInput]="atto.provenienza?.descrizione">
                </div>
                <div labelTextInput class="col-sm-4 bloccodati"
                     [typeLabel]="'text'" [labelInput]="'Numero protocollo'"
                     [valueInput]="atto.numeroProtocollo">
                </div>
                <div labelTextInput class="col-sm-4 bloccodati"
                     [typeLabel]="'date'" [labelInput]="'Data protocollo'"
                     [valueInput]="atto.dataProtocollo">
                </div>
              </div>
              <div class="row">
                <div labelTextInput class="col-sm-3 bloccodati"
                     [typeLabel]="'date'" [labelInput]="'Data deposito'"
                     [valueInput]="atto.dataDeposito">
                </div>
                <div labelTextInput class="col-sm-3 bloccodati"
                     [typeLabel]="'date'" [labelInput]="'Data notifica'"
                     [valueInput]="atto.dataNotifica">
                </div>
                <div labelTextInput class="col-sm-3 bloccodati"
                     [typeLabel]="'boolean'" [labelInput]="'Titolo esecutivo'"
                     [valueInput]="atto.titoloEsecutivo">
                </div>
                <div labelTextInput class="col-sm-3 bloccodati"
                     [typeLabel]="'date'"
                     [labelInput]="'Data apposizione formula esecutiva'"
                     [valueInput]="atto.dataApposizioneFormulaEsecutiva">
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 bloccodati">
                  <p>
                    <label class="col-sm-12">Note</label>
                    <span class="longtext">{{atto.note}}</span>
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <div class="row">
      <div comboModInput class="col-sm-3" [labelInput]="'Tipo atto'"
           [objectReference]="atto.tipoAtto"
           (onReturn)="atto.tipoAtto = $event"
           [optionsCombo]="tipiAtto" [mandatory]="true"
           [ngModel]="atto.tipoAtto" [autocomplete]="true">
      </div>
      <div ng-select-combo class="col-sm-3"
           [label]="'Provenienza'"
           [required]="true"
           [options]="tipiProvenienza"
           [optionSel]="atto.provenienza"
           (onChangeSel)="atto.provenienza = $event">
      </div>
      <div textInput class="col-sm-3"
           [labelInput]="'Numero protocollo'"
           [(ngModel)]="atto.numeroProtocollo">
      </div>
      <div datePickerInput class="col-sm-3"
           [labelInput]="'Data protocollo'"
           [(ngModel)]="atto.dataProtocollo">
      </div>
    </div>
    <div class="row">
      <div datePickerInput class="col-sm-3"
           [labelInput]="'Data Deposito'"
           [(ngModel)]="atto.dataDeposito">
      </div>
      <div datePickerInput class="col-sm-3"
           [labelInput]="'Data Notifica'"
           [(ngModel)]="atto.dataNotifica"
           [mandatory]="true"></div>
      <div checkBoxRadio class="col-sm-2"
           [labelInput]="'Titolo esecutivo'" idInput="titoloEsecutivo-rapid"
           [objectReference]="atto.titoloEsecutivo"
           (change)="atto.dataApposizioneFormulaEsecutiva = undefined"
           (onReturn)="atto.titoloEsecutivo = $event"></div>
      <div datePickerInput class="col-sm-4"
           [labelInput]="'Data apposizione formula esecutiva'"
           [submitPending]="!atto.titoloEsecutivo"
           [(ngModel)]="atto.dataApposizioneFormulaEsecutiva">
      </div>
    </div>
    <div class="row">
      <div textAreaInput class="form-group col-xs-12 col-sm-12"
           [labelInput]="'Note'"
           [(ngModel)]="atto.note">
      </div>
    </div>
    <div class="row">
      <p submitButton
         class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9"
         [labelButton]="'Aggiungi atto'" (click)="aggiungiAtto()"
         [disabled]="!atto.tipoAtto || !atto.provenienza || !atto.dataNotifica">
      </p>
    </div>
  </div>

</div>


<div class="standardpanel">
  <div class="row">
    <p class="col-sm-3 col-xs-3">
      <button type="button" class="btn btn-primary btn-block white" (click)="annulla()">Annulla</button>
    </p>
    <p class="col-sm-3 col-xs-3">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
    </p>
    <p submitButton [disabled]="!isValid" (click)="salva()"
       class="col-sm-3 col-xs-3 col-xs-offset-3 col-sm-offset-3"
       [labelButton]="'Completa'">
    </p>
  </div>
</div>
